import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class QuestionColumn extends Column {
    title = 'employees.onboardingSettings.question';
    property = 'question';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
